import { useCallback, useEffect, useState } from 'react';
import API from '../api/axios';
import toast from 'react-hot-toast';

export default function ArchiveManager() {
  const [kind, setKind] = useState('products');
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);

  const loadArchive = useCallback(async () => {
    try {
      const [productResponse, orderResponse] = await Promise.all([
        API.get('/products/admin/all', { params: { include_archived: true } }),
        API.get('/orders/archive'),
      ]);
      setProducts(productResponse.data.filter(product => product.archived_at));
      setOrders(orderResponse.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Could not load archive');
    }
  }, []);

  useEffect(() => { loadArchive(); }, [loadArchive]);

  const restore = async (type, id) => {
    try {
      await API.post(`/${type}/${id}/restore`);
      toast.success(`${type === 'products' ? 'Product' : 'Order'} restored`);
      await loadArchive();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Could not restore archived item');
    }
  };

  const buttonStyle = {
    padding: '0.45rem 0.8rem', border: '1px solid var(--light-gray)',
    borderRadius: '6px', background: 'var(--white)', cursor: 'pointer',
  };

  return (
    <section>
      <div style={{ display: 'flex', gap: '0.5rem', borderBottom: '1px solid var(--light-gray)', marginBottom: '1rem' }}>
        {['products', 'orders'].map(tab => (
          <button key={tab} type="button" onClick={() => setKind(tab)} style={{
            ...buttonStyle, border: 0, borderBottom: kind === tab ? '3px solid var(--soft-gold)' : '3px solid transparent',
            borderRadius: 0, fontWeight: kind === tab ? '700' : '500', textTransform: 'capitalize',
          }}>{tab} archive ({tab === 'products' ? products.length : orders.length})</button>
        ))}
      </div>

      {kind === 'products' ? products.map(product => (
        <div key={product.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', padding: '0.8rem 0', borderBottom: '1px solid var(--light-gray)' }}>
          <div><strong>{product.name}</strong><div style={{ color: 'var(--mid-gray)', fontSize: '0.82rem' }}>Archived {new Date(product.archived_at).toLocaleDateString()} · stock {product.stock}</div></div>
          <button type="button" onClick={() => restore('products', product.id)} style={buttonStyle}>Restore</button>
        </div>
      )) : orders.map(order => (
        <div key={order.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', padding: '0.8rem 0', borderBottom: '1px solid var(--light-gray)' }}>
          <div><strong>Order #{order.id}</strong><div style={{ color: 'var(--mid-gray)', fontSize: '0.82rem' }}>Archived {new Date(order.archived_at).toLocaleDateString()} · {order.status} · ₹{Number(order.total_amount).toFixed(2)}</div></div>
          <button type="button" onClick={() => restore('orders', order.id)} style={buttonStyle}>Restore</button>
        </div>
      ))}

      {kind === 'products' && !products.length && <p style={{ color: 'var(--mid-gray)' }}>No archived products.</p>}
      {kind === 'orders' && !orders.length && <p style={{ color: 'var(--mid-gray)' }}>No archived orders.</p>}
    </section>
  );
}
